import React from "react";
import PropTypes from "prop-types";
import pojo from "LIB/pojos";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import {
  ASA_APPROVED,
  BLANKET_EXCHANGE_AGREEMENT,
  CAAC_APPROVED,
  DO_NOT_EXCHANGE,
  EASA_APPROVED,
  EXPORT_COMPLIANT,
  FAA_APPROVED,
  MANDATORY_ADDITIONAL_VERBIAGE,
  OTHER_APPROVED,
  REPAIR_STATION_STATUS,
  SECOND_QC_EXPORT_COMPLIANCE_REMINDER_SENT,
  STATUS,
  TCCA_APPROVED,
  THIRD_QC_EXPORT_COMPLIANCE_REMINDER_SENT,
  VENDOR_STATUS,
  VENDOR_TRACE_PREAPPROVAL_REQUIRED,
  UK_CAA_APPROVED,
  EXPORT_APPROVAL_REQUIRED,
  END_USER_AGREEMENT_REQUESTED
} from "MODULES/companies/constants";
import Form from "./Form";

const getYYYYMMFormat = date => (date ? date.slice(0, 10) : null);

const initialValues = company => {
  const pickedValues = pojo(company).pick(
    ASA_APPROVED,
    BLANKET_EXCHANGE_AGREEMENT,
    DO_NOT_EXCHANGE,
    STATUS,
    REPAIR_STATION_STATUS,
    VENDOR_STATUS,
    EXPORT_COMPLIANT,
    EASA_APPROVED,
    END_USER_AGREEMENT_REQUESTED,
    FAA_APPROVED,
    CAAC_APPROVED,
    EXPORT_APPROVAL_REQUIRED,
    TCCA_APPROVED,
    OTHER_APPROVED,
    "other_approval",
    BLANKET_EXCHANGE_AGREEMENT,
    "do_not_quote",
    MANDATORY_ADDITIONAL_VERBIAGE,
    SECOND_QC_EXPORT_COMPLIANCE_REMINDER_SENT,
    THIRD_QC_EXPORT_COMPLIANCE_REMINDER_SENT,
    VENDOR_TRACE_PREAPPROVAL_REQUIRED,
    "business_start_date",
    "consolidated_screening_list_verification_passed",
    "customer_website_review_passed",
    "research_social_media_networks_and_general_online_search_passed",
    "trader_partners_shipment_records_search_passed",
    UK_CAA_APPROVED
  );

  pickedValues.business_start_date = getYYYYMMFormat(
    pickedValues.business_start_date
  );

  return pickedValues;
};

export default function EditApprovals({ open, close, company }) {
  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Company Status</h4>
      </Header>
      <Form
        company={company}
        close={close}
        initialValues={initialValues(company)}
        enableReinitialize
      />
    </Modal>
  );
}

EditApprovals.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  company: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/EditApprovals/EditApprovals.jsx